import { render } from "./MicrophoneAndAudio.vue?vue&type=template&id=e7ef3fae"
import script from "./MicrophoneAndAudio.vue?vue&type=script&lang=js"
export * from "./MicrophoneAndAudio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__